// 客服信箱（contact / terms / privacy 頁面與停權申訴文案共用），依環境由 VITE_SUPPORT_EMAIL 帶入
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL;
